import { ModalService } from '@app/plugins/iview-modal-modify/service';

import i18n from '@app/plugins/i18n';
import { PackageService } from '@pbx/services/PackageService';
import ChangePackage from '@pbx/components/packages/modals/change_package';

class PackageModalService extends ModalService {
  constructor() {
    super(PackageService);
  }

  change(tariff, tariff_end) {
    return this.$confirm({
      title: i18n.t('shared.component.modal.confirm'),
      content: i18n.t('pbx.service-package.modal.change.content', {
        name: `<strong>${tariff.name}</strong>`
      }),
      showCancel: true,
      okText: i18n.t('pbx.service-package.modal.change.buttons.ok'),
      onOk: () => {
        /**
         * Закрываем текущую модалку и открываем новую.
         * Задержка чтобы не закрыть только что открывшуюся модалку
         */
        setTimeout(() => this.change_time(tariff, tariff_end), 300);
      }
    });
  }

  change_time(tariff, tariff_end) {
    return this.$open({
      title: i18n.t('pbx.service-package.modal.change_time.title'),
      width: this.size.default,
      render: h =>
        h(ChangePackage, {
          props: {
            tariff_end: tariff_end,
            tariff: tariff
          },
          on: {
            success: data => {
              this.$emit('success', data);
              this.modal.remove();
            }
          }
        })
    });
  }
}

const instance = new PackageModalService();
export { instance as PackageModalService };
